import { Injectable } from '@angular/core';

const APP_PREFIX = 'HillsCustomerPortal-';

@Injectable()
export class LocalStorageService {
    constructor() {}

    static loadInitialState() {
        return Object.keys(localStorage).reduce((state: any, storageKey) => {
            if (storageKey.includes(APP_PREFIX)) {
                const stateKeys = storageKey
                    .replace(APP_PREFIX, '')
                    .toLowerCase()
                    .split('.')
                    .map(key =>
                        key
                            .split('-')
                            .map(
                                (token, index) =>
                                    index === 0
                                        ? token
                                        : token.charAt(0).toUpperCase() + token.slice(1)
                            )
                            .join('')
                    );
                let currentStateRef = state;
                stateKeys.forEach((key, index) => {
                    if (index === stateKeys.length - 1) {
                        currentStateRef[key] = JSON.parse(localStorage.getItem(storageKey));
                        return;
                    }
                    currentStateRef[key] = currentStateRef[key] || {};
                    currentStateRef = currentStateRef[key];
                });
            }
            return state;
        }, {});
    }

    setItem(key: string, value: any, ignorePrefix = false, json = true) {
        key = !ignorePrefix ? `${APP_PREFIX}${key}` : key;
        value = json ? JSON.stringify(value) : value;
        localStorage.setItem(key, value);
    }

    getItem(key: string, ignorePrefix = false, json = true) {
        key = !ignorePrefix ? `${APP_PREFIX}${key}` : key;
        let item = localStorage.getItem(key);
        item = !item || item === 'undefined'
            ? null
            : item;
        return json ? JSON.parse(item) : item;
    }

    removeItem(key: string, ignorePrefix = false) {
        key = !ignorePrefix ? `${APP_PREFIX}${key}` : key;
        localStorage.removeItem(key);
    }

    /** Tests that localStorage exists, can be written to, and read from. */
    testLocalStorage() {
        const testValue = 'testValue';
        const testKey = 'testKey';
        const errorMessage = 'localStorage did not return expected value';

        this.setItem(testKey, testValue);
        const retrievedValue = this.getItem(testKey);
        this.removeItem(testKey);

        if (retrievedValue !== testValue) {
            throw new Error(errorMessage);
        }
    }
}
